import { render, staticRenderFns } from "./PhoneInput.vue?vue&type=template&id=0aaefb97&scoped=true&"
import script from "./PhoneInput.vue?vue&type=script&lang=js&"
export * from "./PhoneInput.vue?vue&type=script&lang=js&"
import style0 from "./PhoneInput.vue?vue&type=style&index=0&id=0aaefb97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaefb97",
  null
  
)

export default component.exports